<template>
  <div class="app-container">
    <el-row
      :gutter="20"
      style="height:100%;"
    >
      <el-col
        :span="6"
        class="pageContent"
      >
        <div class="grid-content bg-purple">
          <div style="margin-bottom:16px">
            <span class="title">机构目录</span>
            <el-button
              type="primary"
              style="float:right"
              @click="addOrg"
            >添加机构</el-button>
          </div>
          <div
            id="custom-tree"
            v-for='(items, index) in data'
            :key="index"
          >
            <div class="group-item">
              <div
                class="active-group"
                @click.stop=handleNodeClick(items,$event,true)
              >
              <i class="el-tree-node__expand-icon el-icon-caret-right" />
              <i class="el-icon-poc"/>
                <!-- <img
                  class="file"
                  src="@/assets/icon.png"
                /> -->
                
                <div class="title-group">
                  <div class="lable-text">{{items.name}}</div>
                  <div class="icon-list">
                    <i
                      class="iconfont"
                      @click="edit(items)"
                    >&#xe68d;</i>
                    <i
                      class="iconfont"
                      @click="remove(items)"
                    >&#xe64c;</i>
                  </div>
                </div>
              </div>
              <div
                v-for='(itemss, indexs) in items.child'
                v-if='items.child.length>=1'
                :key="indexs"
                class="option-group"
                @click.stop=handleNodeClick(itemss,$event,false)
              >
                {{itemss.name}}
                <div class="icon-list">
                  <i
                    class="iconfont"
                    @click="edit(itemss)"
                  >&#xe68d;</i>
                  <i
                  class="iconfont"
                    @click="remove(itemss)"
                  >&#xe64c;</i>
                </div>
              </div>
            </div>
          </div>

        </div>
      </el-col>
      <el-col
        v-if="isShow"
        :span="18"
      >
        <div style="margin-bottom:16px;margin-left:30px;">
          <span class="title">机构信息</span>
        </div>
        <div class="orinfo">
          <el-form
            ref="submitData"
            :model="submitData"
            :rules="rules"
            label-width="80px"
          >
            <el-form-item label="类型">
              <el-radio-group
                v-model="type"
                @change="radioChange"
              >
                <el-radio
                  :label="1"
                  :disabled="isEdit && type!=1"
                  style="margin-right:32px"
                >部门</el-radio>
                <el-radio
                  :label="2"
                  :disabled="isEdit && type!=2"
                >分组</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="flag"
              label="父机构"
              prop="parentId"
            >
              <el-select
                v-model="submitData.parentId"
                placeholder="请选择"
                @change="selectChange"
              >
                <el-option
                  v-for="item in orgList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="名称"
              prop="name"
            >
              <el-input v-model="submitData.name" />
            </el-form-item>
            <el-form-item
              label="备注"
              prop="remark"
            >
              <el-input
                v-model="submitData.remark"
                type="textarea"
                resize="none"
              />
            </el-form-item>
            <el-form-item style="text-align:center">
                <el-button style="margin-right:8px" @click="isShow=false">取消</el-button>
              <el-button
                type="primary"
                
                @click="save('submitData')"
              >保存</el-button>
             
            </el-form-item>
          </el-form>
        </div>
        <!-- </div>
         -->
      </el-col>
      <!-- 详情 -->
      <el-col
        v-if="!isShow"
        :span="18"
      >
        <div class="grid-content bg-purple">
          <div style="margin-bottom:16px">
            <span class="title">机构信息</span>
          </div>
          <div class="orinfo">
            <el-form label-width="80px">
              <el-form-item label="类型">
                <!-- <span v-if="type=='1'">部门</span>
                <span v-else>分组</span> -->
                <el-radio-group v-model="type">
                  <el-radio
                    :label="1"
                    style="margin-right:32px"
                    :disabled="type!=1"
                  >部门</el-radio>
                  <el-radio
                    :label="2"
                    :disabled="type!=2"
                  >分组</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="flag"
                label="父机构"
              >
                <span class="editColor">{{ orgStatus(info.parentId).val }}</span>
              </el-form-item>
              <el-form-item label="名称">
                <span class="editColor">{{ info.name?info.name:"--" }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span class="editColor">{{ info.remark?info.remark:"--" }}</span>
              </el-form-item>

            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import jq from 'jquery'
import { getDepartInfo, getAllDepartList, updateDepart, deleteDepart } from '@/api/system'
import { validateTwenty, validateFiveHundred, validateParent } from '@/api/validate'
import { statusTrans, emptyTrans, sortDataList, orgTrans } from '@/api/dataTrans.js'
export default {
  data () {
    return {
      isEdit: false,
      ruleForm: {
        name: ''
      },
      isInit: 'false',
      submitData: {
        name: '',
        remark: '',
        type: '1',
        id: '',
        parentId: null
      },
      rules: {
        parentId: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
        name: [{
          required: true,
          validator: validateTwenty,
          trigger: 'blur'
        }],
        remark: [{
          required: false,
          validator: validateFiveHundred,
          trigger: 'blur'
        }]

      },
      data: [],
      defaultProps: {
        children: 'child',
        label: 'name',
        value: 'id'
      },
      flag: false,
      type: '1',
      info: null,
      isShow: false,
      orgList: [],
      value: null,
      info: {},
      isAdd: false,
      parentId: null

    }
  },

  mounted () {
    const _this = this
    this.getList()
  },
  methods: {
    initStyle (_val) {
      var initEl = document.getElementsByClassName('el-tree-node')[1]
      if (initEl) {
        initEl.style.background = _val
      } else {
        setTimeout(function () {
          document.getElementsByClassName('el-tree-node')[1].style.background = _val
        }, 2000)
      }
    },
    // 业务类型
    orgStatus (_val) {
      return orgTrans(_val, this.orgList)
    },
    // 获取部门列表
    getList () {
      const _this = this
      getAllDepartList(function (res) {
        if (res && res.code == 0) {
          _this.orgList = []
          if (res.data[0]) {
            _this.parentId = res.data[0].id
            _this.info = res.data[0]
            _this.type = res.data[0].type
          }
          _this.data = res.data
          if (_this.info.type == '1') {
            _this.flag = false
          } else {
            _this.flag = true
          }
          for (var i = 0; i < res.data.length; i++) {
            _this.orgList.push(res.data[i])
          }
          //  for(var i =0;i<res.data[0].child.length;i++){
          //    _this.orgList.push(res.data[0].child[i])
          //  }

          _this.isInit = true
        }
      })
    },
    // 获取部门信息
    departInfo (data) {
      getDepartInfo({
        id: data
      }).then(res => {
        if (res && res.code == 0) {
          this.submitData.id = res.data.id
          this.submitData.name = res.data.name
          this.submitData.parentId = res.data.parentId
          this.submitData.remark = res.data.remark
          this.type = res.data.type
          this.value = res.data.parentId
        }
      })
    },
    // 添加编辑部门
    addDepart () {
      this.submitData.parentId = this.parentId
      if (this.submitData.type == 1) {
        this.submitData.parentId = 0
      }
      updateDepart(this.submitData).then(res => {
        if (res && res.code == 0) {
          this.getList()
          this.isShow = false
        }
      })
    },
    // 删除部门
    removeDepart (data) {
      deleteDepart({
        ids: data
      }).then(res => {
        if (res && res.code == 0) {
          this.getList()
        }
      })
    },
    addOrg () {
      this.isEdit = false
      this.isAdd = true
      this.isShow = true
      this.submitData.name = ''
      this.submitData.remark = ''
      this.submitData.id = ''
      this.submitData.parentId = null
      this.type = 1
      this.flag = false
      // this.submitData.parentId=this.par/entId
    },
    edit (data) {
      this.isEdit = true
      this.isShow = true
      this.parentId = data.parentId
      setTimeout(() => {
        // 如果type为部门， flag为false，调用接口获取用户数据进行展示
        if (data.type == '1') {
          this.flag = false
        } else if (data.type == '2') {
          this.flag = true
        }
        // 获取部门信息
        this.departInfo(data.id)
        this.isShow = true
      }, 200)
    },
    remove (data) {
      console.log(JSON.stringify(data))
      var waringStr = ""
      if (data.type == 1) {
        waringStr = "删除上级，下级也会被删除,"
      }
      this.$confirm(waringStr + '确定删除吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.removeDepart(data.id)
      }).catch(() => { })
    },
    save (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData.type = this.type
          this.addDepart(this.submitData)
        } else {

        }
      })
    },
    handleNodeClick (data, that, isParent) {
      this.styleRender(that, isParent)
      this.isShow = false
      this.type = data.type
      this.parentId = data.parentId
      this.type = data.type
      if (data.type == '1') {
        this.flag = false
      } else if (data.type == '2') {
        this.flag = true
      }
      if (data) {
        this.info = data
        // this.info.name=data.name
        // this.info.remark=data.remark
        // this.type=data.type
        // this.info.parentId=data.parentId
      }
      // window.console.log(JSON.stringify(this.data))
      // if(data.parentId!==1){
      //  getDepartInfo({id:data.id}).then(res=>{
      //    if(res&&res.code==0){
      //     this.info.name=res.data.name
      //     this.info.remark=res.data.remark
      //     this.type=res.data.type
      //     this.info.parentId=res.data.parentId
      //    }
      //  })
      // }
    },
    getItemInfo (_id) {
      let result = {}
      const _this = this
      if (this.data) {
        var getInfo = function (arr) {
          arr.forEach((item, index) => {
            if (_id == item.id) {
              result = item
              return
            } else if (item.child) {
              getInfo(item.child)
            }
          })
        }
        getInfo(_this.data)
      }
      return result
    },
    radioChange () {
      if (this.type == '1') {
        this.flag = false
      } else {
        this.flag = true
      }
    },
    selectChange (value) {
      // this.parentId = this.value
      this.parentId = value
    },
    // 显示操作按钮
    operateShow (row, column, cell, event) {
      event.path[1].cells[2].children[0].children[0].style.display = 'block'
    },
    operateClose () {
      event.path[1].cells[2].children[0].children[0].style.display = 'none'
    },
    show (row, column, cell, event) {
      event.path[1].cells[3].children[0].children[0].style.display = 'block'
    },
    hide () {
      event.path[1].cells[3].children[0].children[0].style.display = 'none'
    },
    styleRender (that, isParent) {
      if (isParent) {
        jq("#custom-tree .option-group").animate({ height: '0px' }, 0.5)
        jq("#custom-tree .active-group").removeClass('active')
        jq("#custom-tree .el-tree-node__expand-icon").removeClass('expanded')
        jq(that.currentTarget).addClass('active')
        jq(that.currentTarget).children('.el-tree-node__expand-icon').addClass('expanded')
        jq(that.currentTarget).siblings('.option-group').animate({ height: '26px' }, 0.5)
      } else {
        jq("#custom-tree .option-group").removeClass('active-option')
        jq(that.currentTarget).addClass('active-option')
      }

      that.stopPropagation()
    },
  }
}
</script>
<style lang="scss" scoped>
.group-list {
  display: inline-block;
  padding-right: 10px;
  width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.orinfo {
  width: 50%;
  margin: 0 auto;
}
.pageContent {
  border-right: 1px solid #e8e8e8;
  height: 100%;
  // min-height: calc(100vh - 218px);
  // padding: 0 24px;
}
.title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 30px;
}
body .app-wrapper-new-style .app-container {
  padding-left: 24px;
  padding-top: 32px;
}
.el-select {
  width: 100%;
}
.el-tree {
  margin-top: 24px;
  font-size: 12px;
}
.icon {
  display: none;
}
.file {
  width: 16px;
  height: 16px;
  display: inline-block;
  background-size: contain;
  background-image: url("../../../../assets/icon.png");
  margin-right: 8px;
  position: relative;
  top: 3px;
}
.el-tree-node__content .menuIcon {
  display: none;
}
.el-tree-node__children .menuIcon-content {
  position: relative;
  padding-right: 60px;
}
.el-tree-node__children .menuIcon {
  position: absolute;
  right: 0;
  display: none;
  // display: inline-block;
  top: 5px;
}
.el-tree-node__content:hover .menuIcon {
  display: inline-block;
}
// .el-tree-node__children .custom-tree-node :hover .menuIcon {
//   display: inline-block;
// }
/deep/.el-tree-node__label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
}
.editColor {
  color: rgba(0, 0, 0, 0.25);
}
#custom-tree {
  /* width: 300px; */
  font-size: 12px;
  color: #606266;
  line-height: 26px;
  background: #ffffff;
  cursor: pointer;
  position: relative;
  .file {
    width: 16px;
    height: 16px;
    display: inline-block;
    background-size: contain;
    margin-right: 8px;
    position: relative;
    top: 3px;
  }
  .icon-list {
    margin-left: 10px;
    display: none;
    position: absolute;
    right:8px;
    i {
      margin-left: 10px;
    }
  }
  .title-group {
    display: inline-block;
  }
  .title-group .lable-text,
  .option-group .lable-text {
    width: 150px;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    margin-bottom: -9px;
  }
  .el-tree-node__expand-icon {
    cursor: pointer;
    font-size: 12px;
    transform: rotate(0deg);
    transition: transform 0.5s ease-in-out;
  }
  .expanded {
    transform: rotate(90deg);
  }
  .option-group {
    height: 0px;
    padding-left: 40px;
    overflow: hidden;
  }
  .active-group:hover,
  .option-group:hover {
    background: rgba($color: #ffa940, $alpha: 0.1);
    .icon-list {
      display: inline-block;
    }
  }
  .active {
    background: rgba($color: #ffa940, $alpha: 0.85);
    color: #ffffff;
    .el-tree-node__expand-icon {
      color: #ffffff;
    }
    .icon-list {
      display: inline-block;
      
    }
    .iconfont{
      color:rgba(255,255,255,0.85)
    }
    .el-icon-poc{
      background-image: url("../../../../assets/pocket.png");
    }
  }
  .active:hover {
    background: rgba($color: #ffa940, $alpha: 0.85);
  }
  .active-option {
    color: rgba($color: #ffa940, $alpha: 0.85);
    .icon-list {
      display: inline-block;
    }
  }
}
</style>
